import gql from 'graphql-tag';

const ReportFragment = gql`
  fragment ReportFragment on Report {
    description
    ... on ChartReport {
      sets {
        left {
          xLabel {
            title
            unit
            labels
          }
          yLabel {
            title
            unit
            labels
          }
          data {
            ... on ChartReportLine {
              label
              appearance {
                type
                color
                dashArray
              }
              points {
                value
                showLabel
                labelValue
              }
            }
            ... on ChartReportStack {
              label
              bars {
                label
                value
                appearance {
                  color
                }
              }
            }
          }
        }
        right {
          xLabel {
            title
            unit
            labels
          }
          yLabel {
            title
            unit
            labels
          }
          data {
            ... on ChartReportLine {
              label
              appearance {
                type
                color
                dashArray
              }
              points {
                value
                showLabel
                labelValue
              }
            }
            ... on ChartReportStack {
              label
              bars {
                label
                value
                appearance {
                  color
                }
              }
            }
          }
        }
      }
    }
    ... on TableReport {
      data {
        ... on TableReportGraph {
          value
          anchor
          color
        }
        ... on TableReportText {
          text
          appearance {
            bold
          }
        }
        ... on TableReportDate {
          date
          appearance {
            bold
            format
          }
        }
      }
    }
  }
`;

export default ReportFragment;
